import React from "react";

const hardReload = async () => {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch (e) {
    console.error("cache clear failed", e);
  }
  window.location.reload();
};

export class AppErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("App crashed", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="app-crash-screen" className="flex min-h-screen items-center justify-center bg-[#050505] px-6">
        <div className="w-full max-w-md border border-[#1F1F1F] bg-[#0A0A0A] px-6 py-7">
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#C58361]">TJ13 — interface error</p>
          <h1 className="mt-3 font-display text-2xl text-white">Something broke while rendering</h1>
          <p className="mt-2 break-words font-mono text-[11px] text-zinc-500">
            {String(this.state.error?.message || this.state.error)}
          </p>
          <div className="mt-6 flex gap-3">
            <button
              data-testid="app-crash-reload"
              onClick={hardReload}
              className="bg-[#C58361] px-4 py-2 text-sm text-black hover:bg-[#D9956F]"
            >
              Reload app
            </button>
            <button
              data-testid="app-crash-dismiss"
              onClick={() => this.setState({ error: null })}
              className="border border-[#1F1F1F] px-4 py-2 text-sm text-zinc-300 hover:bg-[#111111]"
            >
              Try to continue
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
